import type { ReactNode } from "react";

import Header from "./Header";
import Footer from "./Footer";

interface PageLayoutProps {
    children: ReactNode;
    mainClassName?: string; // Overrides the default spacing around the content
}

// Standard page frame: header, growing main area, footer
const PageLayout = ({ children, mainClassName = "flex-1 my-8" }: PageLayoutProps) => {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className={mainClassName}>{children}</main>
            <Footer />
        </div>
    );
};

export default PageLayout;